import React from 'react';
import Slider from "react-slick";

import './HomeBanner.scss';

import sliderImages from "../../../assets/img/llc/homeSlider"

class HomeBanner extends React.PureComponent {

  renderImages = () => {
    return sliderImages.map((img, index) => (
      <div key={index} className="homeBanner_slider_img_wrap">
        <img src={img} alt={this.props.langs.imgAlt.imgAlt} className="homeBanner_slider_img"/>
      </div>
    ));
  };

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 3000,
      autoplaySpeed: 5000,
      arrows: false,
      fade: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <section className="homeBanner">
        <div className="homeBanner_content">
          <div className="container">
            <h1 className="text-center line">Plastická Chirurgie & <br/> Laserové Léčebné Centrum</h1>
            <h4 className="text-center">
              Toužíte si udržet mladistvý a přitažlivý vzhled a upravit oblasti těla, se kterými nejste
              spokojeni? <br/> Jsou zde pro Vás k dispozici špičkoví chirurgové s bohatými zahraničními zkušenostmi.
            </h4>
          </div>
        </div>
        <div className="homeBanner_slideBtn_wrap">
          <a href="#" className="homeBanner_slideBtn" onClick={this.props.scrollToCategories}>
            <i className="llc-mouse"/>
          </a>
        </div>
        <Slider {...settings} className="homeBanner_slider">
          {this.renderImages()}
        </Slider>
      </section>
    );
  }
}

export default HomeBanner;



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeBanner/HomeBanner.js